export default function computeDynamicDomId(
  staticPrefix: string,
  dynamicSuffix: string | number,
) {
  return `${staticPrefix}-${dynamicSuffix}`;
}
